export const PXPullPlannerRequest = (function () {
	'use strict';

	function init() {
		if (!document.querySelector('.pxblock--pull-planner-request__trigger')) return;
		document.querySelectorAll('.pxblock--pull-planner-request__trigger').forEach((el) => {
			el.addEventListener('click', (ev) => {
				ev.preventDefault();
				MicroModal.show('polywater-modal-pull-planner-request');	

				$('#focus-trap-placeholder').on('focus', () => {
					$('.button--secondary.modal__close').focus()
				})				
			});
		});
	}

	return {
		init: init,
	};
})();
